module.exports = __webpack_public_path__ + "static/media/instagram.dd3e141b.svg";